import ENDPOINTS from '../../../constants/apiEndPoints';
import {axiosInstance} from '../../axiosInstance';

export const handleGetReservationZonesService = async ({
  clientId,
  branchId,
  subBranchId,
}: {
  clientId?: string;
  branchId?: string[];
  subBranchId?: string[];
}) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_RESERVATION_ZONES, {
    params: {clientId, branchId, subBranchId},
  });
  return response?.data?.data;
};
